import { Product } from '@/models/Product';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { getEcommerceBodyForListItems, GTMEventType } from '../GTMEventType';

type ProductBatch = {
  listName: string;
  products: Product[];
};

const productMap = new Map<string, ProductBatch>();
let intervalStarted = false;

export function sendProductToBatch(product: Product, listId: string, listName: string) {
  const existing = productMap.get(listId);

  if (existing) {
    const alreadyIncluded = existing.products.some((p) => p.id === product.id);
    if (!alreadyIncluded) {
      existing.products.push(product);
    }
  } else {
    productMap.set(listId, { listName, products: [product] });
  }

  if (!intervalStarted) {
    intervalStarted = true;

    setInterval(() => {
      productMap.forEach((batch, listId) => {
        if (batch.products.length > 0) {
          sendGTMEvent({
            event: GTMEventType.VIEW_ITEM_LIST,
            ecommerce: getEcommerceBodyForListItems(batch.products, listId, batch.listName),
          });

          batch.products = [];
        }
      });
    }, 1000);
  }
}
